/**
 * Pushes analytics data to dataLayer
 * @param {Object} data
*/
export const pushToDataLayer = data => {
	window.dataLayer.push(data);
};
